import axios from "axios";

export const state = {
    profiles: [],
};

export const getters = {
    profiles: state => state.profiles,
};

export const mutations = {
    setProfile(state, newValue) {
        state.profiles = newValue
    },
};

export const actions = {
    async fetchProfile({ commit }) {
        await axios.get('/facilityprofile').then(res => {
            commit('setProfile', res.data.profile)
        })
    },
};
